
var stateBuilder = require('./stateBuilder.js');
var actionTypes = require('./actionTypes.js');

var internetConnectionSuspendedAction = require('./actions/internet/internetConnectionSuspendedAction.js');
var internetConnectionDisconnectedAction = require('./actions/internet/internetConnectionDisconnectedAction.js');

var passportAction = require('./actions/passport/passportAction.js');
var passportExpiredAction = require('./actions/passport/passportExpiredAction.js');
var staffLoginAction = require('./actions/staffLogin/staffLoginAction.js');
var currentStorefrontAction = require('./actions/storefronts/currentStorefrontAction.js');
var todaysSalesUpdatedDateTimeAction = require('./actions/sales/todaysSalesUpdatedDateTimeAction');
var saleContextAction = require('./actions/sales/saleContextAction.js');
var cashFloatAction = require('./actions/cashFloat/cashFloatAction.js');
var snoozeAction = require('./actions/snooze/snoozeAction.js');
var userNotificationsAction = require('./actions/userNotifications/userNotificationsAction.js');


var alertAction = require('./actions/views/alertDialogue/alertAction.js');
var promptAction = require('./actions/views/prompt/promptAction.js');
var layoutCurrentPageIndexAction = require('./actions/views/layout/layoutCurrentPageIndexAction.js');
var settingsChangeTimestampAction = require('./actions/views/settings/settingsChangeTimestampAction.js');
var loginDialogueAction = require('./actions/views/loginDialogue/loginDialogueAction.js');
var navigationDialogueAction = require('./actions/views/navigationDialogue/navigationDialogueAction');
var navigationPageAction = require('./actions/views/navigationPage/navigationPageAction');
var screenKeyboardAction = require('./actions/views/onScreenKeyboard/screenKeyboardAction');
var tillStatusAction = require('./actions/views/tillStatus/tillStatusAction.js');
var runningLateAction = require('./actions/views/runningLate/runningLateAction');
var screenSaverAction = require('./actions/views/screenSaver/screenSaverAction.js');
var snoozeAction = require("./actions/snooze/snoozeAction.js");

module.exports.reducer = function (previousState, action)
{
    if (!previousState)
    {
        return stateBuilder.createState();
    }

    if (action.type == actionTypes.internetConnectionSuspended)
    {
        return internetConnectionSuspendedAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.internetConnectionDisconnected)
    {
        return internetConnectionDisconnectedAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.passport)
    {
        return passportAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.expirePassport)
    {
        return passportExpiredAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.staffLogin)
    {
        return staffLoginAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.currentStorefront)
    {
        return currentStorefrontAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.todaysSalesUpdatedTime)
    {
        return todaysSalesUpdatedDateTimeAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.saleContext)
    {
        return saleContextAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.cashFloat)
    {
        return cashFloatAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.snooze)
    {
        return snoozeAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.userNotifications)
    {
        return userNotificationsAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.uiAlert)
    {
        return alertAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.uiPrompt)
    {
        return promptAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.uiLayoutCurrentPageIndex)
    {
        return layoutCurrentPageIndexAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.uiSettingsChangeTimestamp)
    {
        return settingsChangeTimestampAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.uiLoginDialogue)
    {
        return loginDialogueAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.uiNavigationDialogue)
    {
        return navigationDialogueAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.uiNavigationPage)
    {
        return navigationPageAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.uiOnScreenKeyboard)
    {
        return screenKeyboardAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.uiLoadingRunningLate)
    {
        return runningLateAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.uiTillStatus)
    {
        return tillStatusAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.screenSaver)
    {
        return screenSaverAction.changeState(previousState, action.payload);
    }

    if (action.type == actionTypes.snooze)
    {
        return snoozeAction.changeState(previousState, action.payload);
    }
    
    return previousState;
}